module.exports = __webpack_public_path__ + "img/b3.11d571e6.png";